// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"count_wrapper__9xPf6","heading":"count_heading__kQ9Y3","count_wrapper":"count_count_wrapper__TxkCT","count_number":"count_count_number___7QzV"};